module.exports = __webpack_public_path__ + "static/media/Soleil-Extrabold.5d56e128.otf";